
import React, { Component } from 'react'

import AWSAPI from '../AWSAPI'

class NaviBar extends Component {
  onNaviBarClicked (url, e) {
    e.preventDefault()
    this.props.history.push(url)
  }
  logout (e) {
    e.preventDefault()
    AWSAPI.logout(this.userRole)
    if ('localStorage' in window) {
      window.localStorage.clear()
    }
    window.location.href = '/' + this.userRoleUrl + '/login' // あえてリロード
  }
  renderNavi () {
    return this.naviSetting.map((menuGroup, index) => {
      const menuList = menuGroup.dropdownMenu.map((menu, index) => {
        return (
          <li key={'menu' + index}>
            <a onClick={(e) => this.onNaviBarClicked(menu.url, e)}>{menu.title}</a>
          </li>
        )
      })
      return (
        <li className='dropdown' key={'menuGroup' + index}>
          <a className='dropdown-toggle' data-toggle='dropdown'>{menuGroup.dropdownToggle}
            <b className='caret hidden-phone' />
          </a>
          <ul className='dropdown-menu'>
            {menuList}
          </ul>
        </li>
      )
    })
  }
  render () {
    const naviMenu = this.renderNavi()
    return (
      <div className='navbar navbar-fixed-top'>
        <div className='navbar-inner'>
          <div className='container'>
            <button ref='toggleMenuButton' className='btn btn-navbar' data-toggle='collapse' data-target='#app-nav-top-bar'>
              <span className='icon-bar' />
              <span className='icon-bar' />
              <span className='icon-bar' />
            </button>
            <a onClick={(e) => this.onNaviBarClicked('/' + this.userRoleUrl, e)} className='brand'><img src='/images/logo.png'alt='ロゴ' /><span className='kw-logo-title'>日本型枠工事業協会</span></a>
            <div id='app-nav-top-bar' ref='toggleMenu' className='nav-collapse'>
              <ul className='nav'>
                {naviMenu}
              </ul>
              <ul className='nav pull-right'>
                <li>
                  <a onClick={(e) => this.logout(e)}>ログアウト</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default NaviBar



// WEBPACK FOOTER //
// ./src/common/component/NaviBar.js